import { IDocumentsFilterCountParts } from './countDocumentsFilter';

export const filterTabValues = {
  source: 'source',
};
export function getDefaultFilterTabs(params: IDocumentsFilterCountParts) {
  const { countSource, countMfr } = params;
  const arrayOpen = [];
  if (countSource > 0 || countMfr > 0) {
    arrayOpen.push(filterTabValues.source);
  }

  return arrayOpen;
}
